<script setup>
import { computed } from "vue";

defineProps({ modelValue: Boolean });
const emit = defineEmits(["update:modelValue"]);

// El server del cliente se deriva del API base (deza-movil -> deza-server,
// demo-movil -> demo-server). Quitamos el sufijo /api para la URL de descarga.
const serverRoot = (process.env.VUE_APP_API_URL || "").replace(/\/api\/?$/, "");
const apkUrl = computed(() => `${serverRoot}/descargas/printbridge`);

// App oficial de Zebra para emparejar la impresora por Bluetooth.
const printConnectUrl =
  "https://play.google.com/store/apps/details?id=com.zebra.printconnect";

const close = () => emit("update:modelValue", false);
</script>

<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="emit('update:modelValue', $event)"
    max-width="480"
  >
    <v-card>
      <v-card-title class="text-h6">Configurar impresión</v-card-title>

      <v-card-text>
        <p class="mb-4">
          Para imprimir tickets necesitas instalar <strong>dos apps</strong> en
          este móvil:
        </p>

        <div class="mb-5">
          <strong>1. App de impresión (PrintBridge)</strong>
          <p class="text-caption mb-2">
            Puente que envía el ticket desde esta app a la impresora.
          </p>
          <v-btn
            color="primary"
            prepend-icon="mdi-download"
            :href="apkUrl"
            target="_blank"
            block
          >
            Descargar PrintBridge
          </v-btn>
          <p class="text-caption mt-1">
            Al abrir el archivo, permite <em>"instalar apps de orígenes
            desconocidos"</em> e instálala.
          </p>
        </div>

        <div class="mb-3">
          <strong>2. Zebra Print Connect</strong>
          <p class="text-caption mb-2">
            App oficial de Zebra para emparejar la impresora por Bluetooth.
          </p>
          <v-btn
            color="primary"
            variant="outlined"
            prepend-icon="mdi-google-play"
            :href="printConnectUrl"
            target="_blank"
            block
          >
            Abrir en Play Store
          </v-btn>
        </div>

        <v-divider class="my-3"></v-divider>

        <p class="text-caption mb-0">
          Después: enciende la <strong>Zebra ZQ320</strong>, empárejala por
          Bluetooth en Print Connect y márcala como impresora por defecto.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="close">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
